import { all, put, takeLatest } from "redux-saga/effects";
import { componentKey, setIsLoggedIn, setIsTokenRefreshing } from "./LoginSlice";
import AuthDataService from "../../services/AuthDataService";
import store from "../../store/store";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import { encryptData } from "../../utils/cryptoUtils";

export const { login, forgotUserPassword, resetUserPassword, getLogInInfo, refreshToken } = {
  login: (payload) => {
    return {
      type: "USER/LOG_IN",
      payload,
    };
  },
  forgotUserPassword: (payload) => {
    return {
      type: "USER/FORGOT_PASSWORD",
      payload,
    };
  },
  resetUserPassword: (payload) => {
    return {
      type: "USER/RESET_PASSWORD",
      payload,
    };
  },
  getLogInInfo: (payload) => {
    return {
      type: "USER/LOGIN_INFO",
      payload,
    };
  },
  refreshToken: (payload) => {
    return {
      type: "USER/REFRESH_TOKEN",
      payload,
    };
  },
};

function* loginAsync(action) {
  try {
    yield put(showLoader());
    const userData = {
      email: action?.payload?.email,
      password: action?.payload.password,
      // EncodeDecodeUtils.encode(action.payload.password)
    };
    const response = yield AuthDataService.login(userData);

    const { status, data } = response;
    if (status) {
      const { data } = response;
      const encryptedUserData = encryptData(data?.user);

      if (!encryptedUserData) {
        throw {
          title: "Encryption failed",
          subTitle: "User data could not be stored.",
        };
      }

      eventEHRCustomToastMessage({
        title: `${data?.user?.name}` || "Login",
        subTitle: `Welcome! You’ve logged in successfully.`,
        status: "success",
      });

      if (action?.payload?.rememberMe) {
        //FOR FACILITY ID WE USER LOGINUSER OBJECT
        localStorage.setItem("loginToken", JSON.stringify(data?.sessionJwt));
        localStorage.setItem(
          "loginRefreshToken",
          JSON.stringify(data?.refreshJwt)
        );
        localStorage.setItem("userLoginData", JSON.stringify(data?.loginUser));

        // IF REMEMBER ME TRUE, SET DATA TO LOCAL STORAGE
        localStorage.setItem("token", JSON.stringify(data?.sessionJwt));
        localStorage.setItem("refreshToken", JSON.stringify(data?.refreshJwt));
        // localStorage.setItem("loginUserData", JSON.stringify(data?.user));
        localStorage.setItem("loginUserData", encryptedUserData);
        localStorage.setItem("userPermission", JSON.stringify(data?.loginUser));

        localStorage.setItem(
          "role",
          JSON.stringify(data?.user?.roleNames?.[0])
        );
        localStorage.setItem(
          "loginUserId",
          JSON.stringify(data?.user?.customAttributes?.userId)
        );
        if (data?.facility && data?.facility?.status) {
          localStorage.setItem(
            "facilityStatus",
            JSON.stringify(data?.facility?.status)
          );
        }

        // Set facility ID from the facility object if it exists
        if (data?.facility?.id) {
          localStorage.setItem("facilityId", data?.facility?.id);
          sessionStorage.setItem("facilityId", data?.facility?.id);
        }

        // Store facilities data
        if (data?.facilities) {
          localStorage.setItem("facilities", JSON.stringify(data?.facilities));
        }
      } else {
        //FOR FACILITY ID WE USER LOGINUSER OBJECT
        localStorage.setItem("loginToken", JSON.stringify(data?.sessionJwt));
        localStorage.setItem(
          "loginRefreshToken",
          JSON.stringify(data?.refreshJwt)
        );
        localStorage.setItem("userLoginData", JSON.stringify(data?.loginUser));

        // IF REMEMBER ME FALSE, SET DATA TO SESSION STORAGE
        sessionStorage.setItem("token", JSON.stringify(data?.sessionJwt));
        sessionStorage.setItem(
          "refreshToken",
          JSON.stringify(data?.refreshJwt)
        );
        // sessionStorage.setItem("loginUserData", JSON.stringify(data?.user));
        sessionStorage.setItem("loginUserData", encryptedUserData);
        sessionStorage.setItem(
          "userPermission",
          JSON.stringify(data?.loginUser)
        );

        sessionStorage.setItem(
          "role",
          JSON.stringify(data?.user?.roleNames?.[0])
        );
        sessionStorage.setItem(
          "loginUserId",
          JSON.stringify(data?.user?.customAttributes?.userId)
        );
        if (data?.facility && data?.facility?.status) {
          sessionStorage.setItem(
            "facilityStatus",
            JSON.stringify(data?.facility?.status)
          );
        }

        // Set facility ID from the facility object if it exists
        if (data?.facility?.id) {
          localStorage.setItem("facilityId", data?.facility?.id);
          sessionStorage.setItem("facilityId", data?.facility?.id);
        }

        // Store facilities data
        if (data?.facilities) {
          sessionStorage.setItem("facilities", JSON.stringify(data?.facilities));
        }
      }
      yield put(setIsLoggedIn(true));
    }
  } catch (error) {
    // USE TOAST MESSAGE LIKE THIS
    eventEHRCustomToastMessage({
      title: error?.title || error?.response?.data?.message || "Error",
      // subTitle: error?.subTitle || "Something went wrong, please try again",
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
    // yield put(setLoginLoadingState({ state: PAGE_STATE.PAGE_READY }));
  }
}
function* forgotUserPasswordAsync(action) {
  yield put(showLoader());

  try {
    const { email, navigate } = action.payload;
    const response = yield AuthDataService.forgotPassword(email);
    if (response?.status) {
      eventEHRCustomToastMessage({
        title: `Password reset email sent successfully`,
        status: "success",
      });
      navigate("/email-check");
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* resetUserPasswordAsync(action) {
  const { payload, navigate } = action.payload;
  yield put(showLoader());
  try {
    const response = yield AuthDataService.resetPassword(payload);
    const { status, message } = response;
    if (status) {
      eventEHRCustomToastMessage({
        title: `Password reset successfully`,
        status: "success",
      });
      navigate("/success-screen");
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* getLogInInfoAsync() {
  try {
    const response = yield AuthDataService.getLogInDetails();
    const { status } = response.data;
    if (status) {
    }
  } catch (error) {
    console.log("err: ", error);
  }
}

function* refreshTokenAsync(action) {
  try {
    yield put(setIsTokenRefreshing(true));
    yield put(showLoader());
    
    const refreshTokenValue = action.payload;
    
    const refreshData = {
      refreshJwt: refreshTokenValue,
      portal: "PRP"
    };
    

    const response = yield AuthDataService.refreshToken(refreshData);
    const { status, data } = response;
    if (status) {
      
      // Handle the response structure - extract user data from nested structure
      const { sessionJwt, refreshJwt, facilities, loginUser, user: userData } = data;
      
      
      // Encrypt user data if available (same as login saga)
      const encryptedUserData = encryptData(userData);
      
      if (!encryptedUserData) {
        throw {
          title: "Encryption failed",
          subTitle: "User data could not be stored.",
        };
      }

      eventEHRCustomToastMessage({
        title: `${userData?.name}` || "Login",
        subTitle: `Welcome! You've logged in successfully.`,
        status: "success",
      });
      
      // Update tokens and user data in storage (same structure as login saga)
      const isRememberMe = localStorage.getItem("token") !== null;
      
      if (isRememberMe) {
        //FOR FACILITY ID WE USER LOGINUSER OBJECT
        localStorage.setItem("loginToken", JSON.stringify(sessionJwt));
        localStorage.setItem("loginRefreshToken", JSON.stringify(refreshJwt));
        localStorage.setItem("userLoginData", JSON.stringify(loginUser));

        // IF REMEMBER ME TRUE, SET DATA TO LOCAL STORAGE
        localStorage.setItem("token", JSON.stringify(sessionJwt));
        localStorage.setItem("refreshToken", JSON.stringify(refreshJwt));
        localStorage.setItem("loginUserData", encryptedUserData);
        localStorage.setItem("userPermission", JSON.stringify(loginUser));

        localStorage.setItem("role", JSON.stringify(data?.user?.roleNames?.[0]));
        localStorage.setItem("loginUserId", JSON.stringify(data?.user?.customAttributes?.userId));
        
        if (loginUser?.facility && loginUser?.facility?.status) {
          localStorage.setItem("facilityStatus", JSON.stringify(loginUser.facility.status));
        }

        // Store facilities data
        if (facilities) {
          localStorage.setItem("facilities", JSON.stringify(facilities));
        }
      } else {
        //FOR FACILITY ID WE USER LOGINUSER OBJECT
        localStorage.setItem("loginToken", JSON.stringify(sessionJwt));
        localStorage.setItem("loginRefreshToken", JSON.stringify(refreshJwt));
        localStorage.setItem("userLoginData", JSON.stringify(loginUser));

        // IF REMEMBER ME FALSE, SET DATA TO SESSION STORAGE
        sessionStorage.setItem("token", JSON.stringify(sessionJwt));
        sessionStorage.setItem("refreshToken", JSON.stringify(refreshJwt));
        sessionStorage.setItem("loginUserData", encryptedUserData);
        sessionStorage.setItem("userPermission", JSON.stringify(loginUser));

        sessionStorage.setItem("role", JSON.stringify(data?.user?.roleNames?.[0]));
        sessionStorage.setItem("loginUserId", JSON.stringify(data?.user?.customAttributes?.userId));
        
        if (loginUser?.facility && loginUser?.facility?.status) {
          sessionStorage.setItem("facilityStatus", JSON.stringify(loginUser.facility.status));
        }

        // Store facilities data
        if (facilities) {
          sessionStorage.setItem("facilities", JSON.stringify(facilities));
        }
      }

      yield put(setIsLoggedIn(true));
      
      
      // Clear URL parameters and navigate to dashboard
      if (typeof window !== 'undefined' && window.location) {
        const url = new URL(window.location.href);
        url.searchParams.delete('token');
        window.history.replaceState({}, '', url.toString());
        
        // Navigate to dashboard
        window.location.href = '/dashboard';
      }
      
      // Return the new token for the interceptor
      return sessionJwt;
    }
  } catch (error) {
    console.error("Token refresh failed:", error);
    eventEHRCustomToastMessage({
      title: "Authentication failed",
      subTitle: "Unable to authenticate with the provided token. Please try again.",
      status: "error",
    });
    console.log("Refresh token error:", error);
    throw error;
  } finally {
    yield put(setIsTokenRefreshing(false));
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([
    takeLatest(login().type, loginAsync),
    // takeLatest(getLogInInfo().type, getLogInInfoAsync),
    takeLatest(forgotUserPassword().type, forgotUserPasswordAsync),
    takeLatest(resetUserPassword().type, resetUserPasswordAsync),
    takeLatest(refreshToken().type, refreshTokenAsync),
  ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
